(() => {

    document.addEventListener('DOMContentLoaded', () => {
        // 1. Select all elements that need animation
        const animatedElements = document.querySelectorAll('[data-animate="shake"]');

        // 2. Define the Intersection Observer options
        const observerOptions = {
            root: null, // Use the viewport as the root
            rootMargin: '0px',
            // Set threshold to 0.1 to trigger when 10% of the element is visible
            threshold: 0.25
        };

        // 3. Define the Callback function
        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                // Check if the element is currently intersecting the viewport
                if (entry.isIntersecting) {
                    // Add the class to trigger the CSS animation
                    entry.target.classList.add('is-scroll-visible');

                    // Stop observing the element after it has animated
                    observer.unobserve(entry.target);
                }
            });
        };

        // 4. Create the Observer instance
        const observer = new IntersectionObserver(observerCallback, observerOptions);

        // 5. Start observing all target elements
        animatedElements.forEach(element => {
            observer.observe(element);
        });
    });

})();